import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components';
import { init } from "../../config/provider";
import { userInfoContext } from '../../Context/userInfoContext';
import { userProviderContext } from '../../Context/userProviderContext';

const Root = styled.div``;
const Container = styled.div``;
const TextWrapper = styled.div``;
const Button = styled.button`
 padding: 10px 20px;
    border-radius: 10px;
    border: none;
    font-size: 16px;
    font-weight: 700;
    margin: 10px 12px;
    cursor: pointer;
    background-color:rgb(146 95 146);
    color: white;
`;

const Wallet = ({ allContractDetails, setAllContractDetails }) => {
  const [address, setAddress] = useState("");
  const {setUserToken}=useContext(userInfoContext)
  const {setUserProvider}=useContext(userProviderContext);
  useEffect(() => {
    if (allContractDetails?.address) {
      const address = allContractDetails.address;
      setAddress(address)
    } else {
      setAddress("")
    }
  }, [allContractDetails])

  
  const connectWallet = async () => {
    console.log('connect wallet call here')
    init().then(async (data) => {
      setAllContractDetails(data)
      setUserToken(data?.idToken?.idToken);
      setUserProvider(data?.loginType)
    }).catch((err) => {
      console.log('err', err)
    })
  }
  const logoutWallet = async () => {
    await allContractDetails.logout().then(async (data) => {
      console.log('logout data', data)
      setAllContractDetails({})
      setUserToken(null)
      setUserProvider(null)
    }).catch((err) => {
      console.log('err', err)
    })
  }

  return (
    <Root>
      <Container>
        <TextWrapper>
          {
            address ? (
              <>
                <span style={{ color: 'black' }}>{address.slice(0, 6)}...{address.slice(address.length - 4, address.length)}</span>
                <Button styled={{ margin: "0 10px" }} onClick={logoutWallet}> Logout </Button>
              </>
            ) : <Button onClick={connectWallet}> Connect Wallet </Button>
          }
        </TextWrapper>
      </Container>
    </Root>
  )
}

export default Wallet